// AGC: Origami Battles entry point
// AGC: Uses shared providers from @farmprohub/shared

import React from 'react'
import ReactDOM from 'react-dom/client'
import { WalletProvider, setAppMetadata } from '@farmprohub/shared'
import App from './App'
import './index.css'

// AGC: Configure app metadata for Origami Battles
setAppMetadata({
  name: 'Origami Battles',
  description: 'A strategic battle game on Base blockchain with Farcaster integration',
  url: 'https://origamibattle.app',
  icon: 'https://origamibattle.app/logo.png',
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <WalletProvider>
      <App />
    </WalletProvider>
  </React.StrictMode>
)

